import React from "react";
import { cn } from "../../lib/utils";

const Card = ({ className, children }) => {
  return <div className={cn("card", className)}>{children}</div>;
};

const CardHeader = ({ className, children }) => {
  return <div className={cn("card-header", className)}>{children}</div>;
};

const CardContent = ({ className, children }) => {
  return <div className={cn("card-content", className)}>{children}</div>;
};

export { Card, CardHeader, CardContent };
